import Indicator from '../Indicator';

/** Accumulation / Distribution Line indicator */
export default class ADLIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator Name
	 * @property {string} description - Indicator Description
	 */
	_getDefaultParams() {
		return {
			id: 'adl',
			name: 'Accumulation / Distribution',
			description: 'The Accumulation/Distribution Line is calculated by adding or subtracting a portion of each day\'s volume from a cumulative total. The amount of volume to add or subtract is based on the relationship between the close and the high-low range. The closer the close is to the high, the more volume is added to the cumulative total. Conversely, the closer the close is to the low, the more volume is subtracted from the cumulative total. If the close is exactly midway between the high and low prices, nothing is added to the cumulative total.',
			componentSeries: [
				{ id: 'adl' }
			]
		};
	}

	/** @param {object} data - Symbol data object */
	render(data, sessionType) {
		this.cumulativeAdjustment = this._getCumulativeAdjustment();
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
